import React, { useId, useState } from 'react';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import VisibilityOffOutlinedIcon from '@mui/icons-material/VisibilityOffOutlined';
import { FIELD_BOX_CLASS, FIELD_INPUT_CLASS, FIELD_LABEL_CLASS } from './accountSettingsClasses';

interface PasswordFieldProps {
  label: string;
  value: string;
  onChange: (value: string) => void;
  autoComplete: 'new-password' | 'current-password';
  disabled?: boolean;
}

const PasswordField: React.FC<PasswordFieldProps> = ({ label, value, onChange, autoComplete, disabled }) => {
  const inputId = useId();
  const [isVisible, setIsVisible] = useState(false);

  return (
    <div className="flex w-full flex-col gap-1.5">
      <label htmlFor={inputId} className={FIELD_LABEL_CLASS}>{label}</label>
      <div className={FIELD_BOX_CLASS}>
        <input
          id={inputId}
          type={isVisible ? 'text' : 'password'}
          autoComplete={autoComplete}
          value={value}
          onChange={(event) => onChange(event.target.value)}
          className={FIELD_INPUT_CLASS}
          disabled={disabled}
        />
        <button
          type="button"
          onClick={() => setIsVisible((visible) => !visible)}
          className="flex shrink-0 items-center border-none bg-transparent p-0 text-[#76767f]"
          aria-label={isVisible ? `Hide ${label.toLowerCase()}` : `Show ${label.toLowerCase()}`}
        >
          {isVisible
            ? <VisibilityOffOutlinedIcon sx={{ fontSize: 20 }} aria-hidden />
            : <VisibilityOutlinedIcon sx={{ fontSize: 20 }} aria-hidden />}
        </button>
      </div>
    </div>
  );
};

export default PasswordField;
